import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';

@Component({
    selector: 'json-content-table',
    templateUrl: './json-content-table.component.html',
    styleUrls: ['./json-content-table.component.scss'],
    standalone: false
})
export class JsonContentTableComponent implements OnInit {

  @Input() json: any;

  @Input() displayStyle: string;

  @Input() title: string;

  @Input() transformTimestamp: boolean;

  public content: any;

  public isLoading = false;

  warning = false;

  error = false;

  constructor() {
  }

  ngOnInit() {
    this.isLoading = true;
    if (this.displayStyle === 'log') {
      this.content = this.returnLogTable(this.json);
    }
    if (this.displayStyle === 'detail') {
      this.content = this.returnDetailTable(this.json);
    }
    this.isLoading = false;
  }

  private returnDetailTable(json) { // creates Detail Table dynamically //

    const array = [];
    let index = 0;

    for (const key in json) {

      if (json.hasOwnProperty(key)) {

        let content = json[key];
        let link = false;
        let children = false;

        if (key === 'autoUpdateInterval') { // convert from Ms to Minutes //
          content = json[key] / (1000 * 60) + ' min (' + json[key] + 'ms)';
        } else if (typeof json[key] === 'string' && json[key].indexOf('http') !== -1) { // display as html link //
          link = true;
        } else if (this.transformTimestamp && typeof json[key] === 'number' && json[key] > 0) { // convert number to date
          content = moment(new Date(json[key])).format('DD.MM.YY  HH:mm');
        } else if (typeof json[key] === 'object' && json[key] instanceof Date) {
          content = moment(json[key]).format('DD.MM.YY  HH:mm');
        } else if (typeof json[key] === 'object') { // if entry is object, recursive Display //
          children = true;
          const childrenElements = this.returnDetailTable(json[key]) || [];
          content = '<table>';
          childrenElements.forEach(function(child) {
            if (child.link) {
              child.content = '<a href=' + child.content + '" target="_blank"><i class="material-icons">link</i>' + child.content + '</a>';
            }
            content += '<tr><td>' + child.key + ': </td><td>' + child.content + '</td></tr>';
          });
          content += '</table>';
        }
        array[index] = { 'key': key, 'content': content, 'link': link, 'children': children };
        index++;
      }
    }
    if (!array.length) {
      return false;
    }
    return array;
  }

  private returnLogTable(json) { // creates Detail Table dynamically //

    const array = [];
    const errors = ['Silly', 'Debug', 'Log', 'Warning', 'Error', 'Exception', 'Fatal'];
    let index = 0;
    let warning = false;
    let error = false;

    for (const key in json) {
      if (json.hasOwnProperty(key)) {
        let content = json[key];
        let children = false;

        if (key === 'level') { // Style for Error Levels //
          content = errors[(json[key]) + 1]; // Error level starts add -1
          if (json[key] === 2) { warning = true; }
          if (json[key] > 2) { error = true; }
        }
        if (key === 'created') {
          content = moment(json[key]).format('DD-MM-YYYY  HH:mm');
        }
        if (typeof json[key] === 'object') { // if entry is object, recursive Display //
          children = true;
          const childrenElements = this.returnLogTable(json[key]) || [];
          content = '<table>';
          childrenElements.forEach(function(child) {
            warning = child.warning; // let errors bubble up
            error = child.error;
            content += '<tr><td>' + child.key + '</td><td>' + child.content + '</td></tr>';
          });
          content += '</table>';
        }
        array[index] = { 'key': key, 'content': content, 'children': children, 'warning': warning, 'error': error };
        index++;
      }
    }

    if (!array.length) {
      return false;
    }
    this.isLoading = false;
    return array;
  }
}
